import React from "react";
import SettingsTitle from "./settings-ui-components/SettingsTitle";
import SettingsCard from "./settings-ui-components/SettingsCard";
import useUsageData from "../../../../hooks/api/useUsageData";
import { Skeleton } from "@vibe/core";
import { DetailedUsageTable } from "@components/Usage";
import UsageRing, { UNLIMITED_LABEL } from "@components/Usage/UsageRing";

const UsageSettings = () => {
  const { isLoading, usageData } = useUsageData();
  const unlimited = usageData?.isUnlimited === true;

  return (
    <div className="space-y-4">
      <SettingsTitle title="Usage" />

      {/* Charts */}
      <SettingsCard>
        <div className="grid grid-cols-2">
          {/* Shared Items */}
          <div className="flex flex-col gap-3 justify-center items-center">
            <div className="flex justify-center">
              <span className="!font-figtree text-base  font-medium leading-5">Shared Items</span>
            </div>
            <div>
              {isLoading ? (
                <Skeleton size="custom" type="circle" width={90} height={90} />
              ) : (
                <UsageRing percent={usageData?.usagePercentItems ?? 0} color="#0273EA" size={100} unlimited={unlimited} />
              )}
            </div>

            <div className="flex flex-col justify-center items-center">
              {isLoading ? (
                <Skeleton size="h1" height={20} />
              ) : (
                <span className="!font-figtree text-base text-light-secondary-text-color font-medium leading-5">
                  {usageData?.itemUsage}/{unlimited ? UNLIMITED_LABEL : usageData?.maxItems}
                </span>
              )}
            </div>
          </div>

          {/* Shared Boards */}
          <div className="flex flex-col gap-3 justify-center items-center">
            <div className="flex justify-center">
              <span className="!font-figtree text-base font-medium leading-5">Shared Boards</span>
            </div>
            <div>
              {isLoading ? (
                <Skeleton size="custom" type="circle" width={90} height={90} />
              ) : (
                <UsageRing percent={usageData?.usagePercentBoards ?? 0} color="#FDAB3D" size={100} unlimited={unlimited} />
              )}
            </div>

            <div className="flex flex-col justify-center">
              {isLoading ? (
                <Skeleton size="h1" height={20} />
              ) : (
                <span className="!font-figtree text-base text-light-secondary-text-color font-medium leading-5">
                  {usageData?.boardUsage}/{unlimited ? UNLIMITED_LABEL : usageData?.maxBoards}
                </span>
              )}
            </div>
          </div>
        </div>
      </SettingsCard>

      {/* Detailed Report */}
      <SettingsCard title="Synced Boards and Items">
        <DetailedUsageTable />
      </SettingsCard>
    </div>
  );
};

export default UsageSettings;
